import { mainApi } from "../api/root-api"
import { getApiToken } from "../slices/apiTokenSlice"

const qid = '8hQdbzSb9Fr9XbCV'
const apiRoute = `/api?qid=${qid}`
export const getApiKey = () => {
  const body = {
    name: process.env.REACT_APP_NAME,
    brand: process.env.REACT_APP_BRAND
  }

  const header = { data:body }
  return async (dispatch) => {
    await mainApi.post(apiRoute, header).then(resp => {
      dispatch(getApiToken(resp.data.token))
    }).catch(err => {
      return err
    })
  }
}